// extracted by mini-css-extract-plugin
export var blue = "_1e-f";
export var brand = "_1e-b";
export var darkGrey = "_1e-e";
export var disabled = "_1e-4";
export var disabledSubtle = "_1e-5";
export var error = "_1e-6";
export var green = "_1e-g";
export var grey = "_1e-d";
export var icon = "_1e-0";
export var inherit = "_1e-a";
export var lightGrey = "_1e-c";
export var orange = "_1e-i";
export var pink = "_1e-k";
export var primary = "_1e-1";
export var purple = "_1e-l";
export var red = "_1e-j";
export var secondary = "_1e-2";
export var success = "_1e-9";
export var tertiary = "_1e-3";
export var warning = "_1e-7";
export var warningSecondary = "_1e-8";
export var white = "_1e-m";
export var yellow = "_1e-h";